/*
 * (c) Copyright, 2021, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useEffect, useRef, useState, useLayoutEffect } from 'react'
import { Button, Form } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { useServiceContext } from '~/root'
import Modal from '../Modal'
import PdfViewer from '../PdfViewer'
import { Link, useNavigate } from 'react-router'

const PdfContainer = styled.div``
const CustomModalBody = styled.div`
  padding: 0 !important;
`

interface AckViewDocDialogProps {
  pdfSrc:
    | string
    | { service: () => Promise<{ url: string | null; uuidToCheckState: string | null | undefined; message?: string }> }
  pdfInfo?: any
  thumbnailId?: string | number
  downloadFn?: () => void
  onClose?: () => void
  isEosOverviewFlow?: boolean
  fileName?: string
  isReferenceModal?: boolean
}

const AckViewDocDialog: React.FC<AckViewDocDialogProps> = ({
  pdfSrc,
  pdfInfo,
  thumbnailId,
  downloadFn,
  onClose,
  isEosOverviewFlow,
  fileName,
  isReferenceModal
}) => {
  const navigate = useNavigate()
  const context = useServiceContext()
  const { t: translate } = useTranslation()
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [viewerHeight, setViewerHeight] = useState<string>('')
  const refHeader = useRef<HTMLDivElement>(null)
  const refFooter = useRef<HTMLDivElement>(null)

  useEffect(() => {
    setIsOpen(true)
  }, [])

  const doClose = () => {
    setIsOpen(false)
    if (onClose) {
      onClose()
    }
  }

  useLayoutEffect(() => {
    if (isOpen && refHeader.current && refFooter.current) {
      const height = window.innerHeight - (refHeader.current.offsetHeight + refFooter.current.offsetHeight)
      setViewerHeight(height + 'px')
    }
  }, [isOpen])

  return (
    <Modal
      show={isOpen}
      title={translate(
        isEosOverviewFlow || isReferenceModal
          ? 'FILE_PREVIEW_REFERENCE_DOCUMENT_TITLE'
          : 'EOS_DASHBOARD_TASK_ACKNOWLEDGEMENT_VIEW_DOC_TITLE'
      )}
      handleClose={doClose}
      className={`${isEosOverviewFlow || isReferenceModal ? 'study-overview-preview' : ''} level-two-modal`}
    >
      <div ref={refHeader as React.RefObject<HTMLDivElement>}>
        <Modal.Body>
          <CustomModalBody>
            {!!(isEosOverviewFlow || isReferenceModal) && (
              <div className="d-flex align-left mb10 fs12 mt10 file-text-container">
                <Form.Label className="file-text">{translate('FILE_PREVIEW_REFERENCE_DOCUMENT_NAME')}</Form.Label>
                <div className="ellipsis file-text">
                  <Link to={`/show-file/${pdfInfo?.fsiId}`} onClick={doClose}>
                    {fileName}
                  </Link>
                </div>
              </div>
            )}
            <PdfContainer
              className="d-flex align-self-stretch flex-grow"
              style={{ minHeight: viewerHeight || undefined }}
            >
              <PdfViewer
                src={pdfSrc}
                thumbnailId={typeof thumbnailId === 'number' ? String(thumbnailId) : thumbnailId}
                downloadFunction={downloadFn}
                printLog={pdfInfo}
                className="doc-pdf-container d-flex align-self-stretch flex-grow"
              />
            </PdfContainer>
          </CustomModalBody>
        </Modal.Body>
      </div>
      <div ref={refFooter as React.RefObject<HTMLDivElement>}>
        <Modal.Footer>
          <Button variant="primary" onClick={doClose} id="9063f19e-5c0a-43dc-99c6-4d56e507303e">
            {translate('OK')}
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  )
}

export default AckViewDocDialog
